import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  ElementRef,
  inject,
  input,
  model,
  Renderer2,
  TemplateRef,
} from '@angular/core';

@Component({
  selector: 'mds-tab-item',
  templateUrl: './tab-item.component.html',
  styleUrl: './tab-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet],
})
export class TabItemComponent<TabId, Template = undefined> {
  id = input.required<TabId>();
  title = input.required<string>();
  dataTest = input.required<string>();
  active = model<boolean>(false);
  icon = input<string>();
  count = input<number>();
  label = input<string>();
  countLoaded = input<boolean>(false);
  totalCount = input<number>();

  private readonly elementRef = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  // content-projection doesn't destroy the content of other tabs
  // however templateRef allows for that functionality
  // use the tab-item-template.directive to enable templateRef usage in the tabs
  templateRef: TemplateRef<Template> | undefined;

  _ = effect(() =>
    this.active()
      ? this.renderer.addClass(this.elementRef.nativeElement, 'active')
      : this.renderer.removeClass(this.elementRef.nativeElement, 'active')
  );
}
